import React from 'react';
import useGame from 'hooks/useGame';

export default function Game(props) {
  const gameRef = useGame(props.config);

  return <div className="is-overlay" ref={gameRef}></div>;
}
